import type { FaireProductEntity } from "../../entity_types/product";

export const p_jph2q9svwj: FaireProductEntity = {
  token: "p_jph2q9svwj",
  type: "product",
  name: "PALLA - Burnt Orange | Multipurpose Plant Stand",
  brandToken: "b_cq3bdzqtzm",
  brandName: "Upton",
  imageUrl:
    "https://cdn.faire.com/fastly/1ec5520ec7c0e66a81fe93abb135d3cca999953a897ea7bb4c2d9c04a8c48f26.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/51951bd63fd8f3c63c5f9ba1c3054acefda5a40ab4b48f77e10dec45512a2460.jpeg",
    "https://cdn.faire.com/fastly/21c975ec59c8c87b58c9ccb8b5a0f63987e6663e25c29b7304e2cf89de9b6f4c.jpeg",
    "https://cdn.faire.com/fastly/c98794e528eef07ecc6561a8e596bd7b501ea4cb6fb13b1dc9cf412242474dea.jpeg",
    "https://cdn.faire.com/fastly/e452d7e5dc37464c7f9f2f3568e3f406b51d9f7d420e2102262923586ee4cb51.jpeg",
    "https://cdn.faire.com/fastly/94067d89495f48f80332954b51795c0b0ef51c945efcb7c57bb37ae5728616c9.jpeg",
  ],
  priceDollars: 44.5,
  description:
    "Made to be used as a plant stand, fruit bowl, or anything else you can think up, the Palla is a multipurpose steel stand with a powder coat finish. Designed with a reversible base for two display options.\n\nWith a modern design and clean aesthetic, the Palla is lightweight to be easily moved around the home. Perfect for indoor use on the floor, counter, or tabletop, as well as outdoor use on the patio, deck, or garden.\n\nMakes a great gift for plant lovers, gardeners, and design enthusiasts. Perfect for flower and plant shops, gift shops, interior design and lifestyle boutiques, and any shop looking to stock artist owned small businesses.\n\nSpecs:\n- Size: 9.25”W x 9.25”D x 10”H\n- Steel with a powder coat finish.\n- Holds pots up to 9.25” in diameter.\n- Stand ships flat. Light assembly required (don’t worry, it’s easy!)",
  tags: [],
  msrpDollars: 89,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-09-01T22:13:12.464Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
